var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucessGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#7FC128"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3768 31.3484C18.4646 30.3119 16.8849 30.2111 15.8484 31.1232C14.8119 32.0354 14.7111 33.6151 15.6232 34.6516L19.3768 31.3484ZM28.5 45.5L26.6232 47.1516C27.1114 47.7063 27.8199 48.0166 28.5586 47.9993C29.2974 47.982 29.9906 47.6387 30.4522 47.0617L28.5 45.5ZM50.4522 22.0617C51.3147 20.9836 51.1399 19.4104 50.0617 18.5478C48.9836 17.6853 47.4104 17.8601 46.5478 18.9383L50.4522 22.0617ZM15.6232 34.6516L26.6232 47.1516L30.3768 43.8484L19.3768 31.3484L15.6232 34.6516ZM30.4522 47.0617L50.4522 22.0617L46.5478 18.9383L26.5478 43.9383L30.4522 47.0617Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessGreen);
export default __webpack_public_path__ + "static/media/sucessGreen.94f8158be4c4eb5d58dcb1e74d40916b.svg";
export { ForwardRef as ReactComponent };